import { render, staticRenderFns } from "./active-requests.vue?vue&type=template&id=216d8934&scoped=true&"
import script from "./active-requests.vue?vue&type=script&lang=js&"
export * from "./active-requests.vue?vue&type=script&lang=js&"
import style0 from "./active-requests.vue?vue&type=style&index=0&id=216d8934&scoped=true&lang=css&"
import style1 from "./active-requests.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d8934",
  null
  
)

export default component.exports